/**
 * Labstep
 *
 * @module components/Tag/Manager
 * @desc Tag Manager component
 */

import { EntityListToggle as EntityToggleList } from 'labstep-web/components/Entity/ListToggle';
import { TagList } from 'labstep-web/components/Tag/List';
import { ICONS } from 'labstep-web/constants/icons';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { Button } from 'labstep-web/core/Button';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import type { TagManagerProps } from './types';

export const TagManager: React.FC<TagManagerProps> = ({
  parentEntity,
  activeGroup,
  viewComponent,
  open,
  onClose,
}) => (
  <Modal
    header="Manage Tags"
    viewComponent={
      viewComponent ||
      (({ toggleModal }) => (
        <Popup
          trigger={
            <Button
              onClick={toggleModal}
              icon={ICONS.tag.primary}
              circular
            />
          }
          content="Manage Tags"
          size="mini"
        />
      ))
    }
    initialModalState={open}
    onClose={onClose}
    content={
      <EntityToggleList
        parent={parentEntity}
        entityName={Tag.entityName}
        labelKey="name"
        caseSensitive={false}
        extraParams={{
          group_id: activeGroup?.id,
        }}
        creatable
        createBody={{ type: parentEntity.entityName }}
        // One off until we come up with a more generic one
        placeholder="Search tags in this workspace or create a new one..."
        actionMessageIcon="tags"
        list={({ entities }) => (
          <TagList
            tags={entities as Tag[]}
            parentEntity={parentEntity}
          />
        )}
      />
    }
  />
);

export default withActiveGroup(TagManager);
